import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer_text t-primary">
        © 2025 Edaface Listing platform. All Rights Reserved.
      </p>
    </footer>
  );
}

export default Footer;